




import {Vue, Component} from 'vue-property-decorator'

import ConfigSent  from '@/components/ConfigSent.vue'

@Component({
  components: {
      ConfigSent
  }
})
export default class ConfigSentView extends Vue {
}
